
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppAdministratorResourcesExercisesListFormRemove} from "@/models/app/administrator/resources/exercises/list/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "exercise",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class AppAdministratorResourcesExercisesListFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  exercise: AppAdministratorResourcesExercisesListFormRemove = new AppAdministratorResourcesExercisesListFormRemove();

  formData: AppAdministratorResourcesExercisesListFormRemove = new AppAdministratorResourcesExercisesListFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/administration/exercise/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getExercises');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.exercise;
  }

  resetFormData(): void {
    this.formData = new AppAdministratorResourcesExercisesListFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
